import React from 'react';

import ListItem from 'onboarding/common/forms/dropdown/dropdown/ListItem';

const InputTypeDropdown = ({ items, onSelectItem }) => {
  const handleClick = (item) => void onSelectItem(item);
  return (
    <div data-bem="InputTypeDropdown" className="item-list">
      {items.map((item) => (
        <ListItem item={item} onClickHandler={handleClick} key={item.id} />
      ))}
    </div>
  );
};

export default InputTypeDropdown;
